export default __webpack_public_path__ + "static/media/plain-sticker-G.b58d0f16.png";